import React from 'react';
import OrderOptions from './OrderOptions';

const index = ({ isForMobile = false }) => {
    return <OrderOptions isForMobile={isForMobile} />;
};

export default index;
